export default __webpack_public_path__ + "static/media/Hair Split End Hair Kit 1.156197d7.jpg";